<template>
  <div>
    <!-- 商品服务 -->
    <section class="product-service" @click="showDetails = true">
      <p>服务</p>
      <ul class="services">
        <li v-for="(item, index) in shortList" :key="index">
          <i :class="['iconfont', item.icon]"></i
          ><span v-text="item.name"></span>
        </li>
      </ul>
      <i class="iconfont icongengduo"></i>
    </section>

    <!-- 服务细节 -->
    <van-action-sheet v-model="showDetails" title="保障服务">
      <ul class="service-details">
        <li v-for="(item, index) in list" :key="index">
          <i :class="['iconfont', item.icon]"></i>
          <p v-text="item.name"></p>
          <p v-text="item.desc"></p>
        </li>
      </ul>
    </van-action-sheet>
  </div>
</template>

<script>
  import { SERVICES } from './config';

  export default {
    name: 'DetailService',
    data() {
      return {
        list: SERVICES,
        showDetails: false,
      };
    },
    computed: {
      shortList() {
        return this.list.slice(0, 6);
      },
    },
  };
</script>

<style lang="scss" scoped>
/* 商品服务 */
.product-service {
  display: flex;
  align-items: center;
  margin-top: 5px;
  padding: 10px 20px;
  font-size: 14px;
  color: #999;
  background-color: #fff;
  cursor: pointer;
}

.product-service .services {
  flex: 1;
  display: flex;
  margin: 0 30px -10px 20px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #666;
}

.product-service .services > li {
  width: 33.3%;
  margin-bottom: 10px;
}

.product-service .services .iconfont {
  margin-right: 5px;
  color: #e44837;
}

/* 服务细节 */
.service-details {
  display: flex;
  flex-direction: column;
  padding: 0 20px 30px;
  line-height: 1.4;
}

.service-details > li {
  position: relative;
  padding: 10px 30px;
  border-top: 1px solid #eee;
}

.service-details .iconfont {
  position: absolute;
  left: 0;
  top: 10px;
  color: #e44837;
}

.service-details > li p:first-of-type {
  font-size: 14px;
  color: #333;
}

.service-details > li p:last-of-type {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
}
</style>
